class PredictiveSearch extends HTMLElement {
	constructor() {
		super();

		this.input = this.querySelector('input[type="search"]');
		this.predictiveSearchResults = this.querySelector('#predictive-search');

		this.input.addEventListener(
			'input',
			this.debounce(event => {
				this.onChange(event);
			}, 300).bind(this)
		);
	}

	onChange() {
		const searchTerm = this.input.value.trim();
		let customMenu = document.querySelector('.custom-menu');
		if (!searchTerm.length) {
			customMenu.style.display = 'block';
			this.close();
			return;
		}
		customMenu.style.display = 'none';
		this.getSearchResults(searchTerm);
	}

	getSearchResults(searchTerm) {
		fetch(window.Shopify.routes.root + `/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=4&section_id=predictive-search`)
			.then(response => {
				if (!response.ok) {
					var error = new Error(response.status);
					this.close();
					throw error;
				}

				return response.text();
			})
			.then(text => {
				const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
				this.predictiveSearchResults.innerHTML = resultsMarkup;
				this.open();
			})
			.catch(error => {
				this.close();
				throw error;
			});
	}

	open() {
		this.predictiveSearchResults.style.display = 'block';
	}

	close() {
		this.predictiveSearchResults.style.display = 'none';
	}

	debounce(fn, wait) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn.apply(this, args), wait);
		};
	}
}

customElements.define('predictive-search', PredictiveSearch);
